import {mapState} from "vuex";
import util from "@/mixins/util";
import {getTokenObj, logout} from "@/mixins/Auth";
import moment from "moment";
import Swal from 'sweetalert2'
export default {
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        getAdminType() {
            let tokenObj = getTokenObj();
            if(!tokenObj) {
                return false;
            }
            if(tokenObj.g_type === 'ADMIN' || tokenObj.g_type == 'admin') {
                return 'admin'
            }else if(tokenObj.g_type === 'creator') {
                return 'admin'
            }else if(tokenObj.g_type === 'member') {
                return 'member'
            }else if(tokenObj.g_type === 'manage') {
                return 'manage'
            }
            return false;
        },
        getIsSuper() {
            if(this.UserInfo.cmsAuthority.isSuper === 1) {
                return true;
            }
            return false;
        },
    },
}
